<template>
    <div>
        <div class="modal-overlay active"  @click="closeDialog()"></div>
        <div class="modal">
            <div class="modal__header">
                <h2 id="emailModalTitle" class="headline-s">Update User</h2>
                <CloseIcon @click="closeDialog()" class="modal__header--close" alt="Close Modal" aria-label="Close" />
            </div>
            <div class="modal__body flex-column">
                <div class="notification notification-error" v-show="errors.email">
                    <p class="paragraph-details"><strong>Error:</strong> {{ errors.email }}</p>
                </div>
                <div class="input-folder">
                    <div class="input-folder--input">
                        <PrimeInputText 
                            v-model="form.username" 
                            id="username" 
                            placeholder=" " 
                            required
                            :class="{'invalid-state-input': form.errors.username}"
                        />
                        <label :class="{
                            'invalid-state': form.errors.username,
                        }" for="username">
                            <p class="paragraph-default">User Name</p>
                        </label>
                    </div>
                    <div class="input-folder--support">
                        <p class="input-suport-text invalid-state" v-if="form.errors.username"> {{ form.errors.username }}</p>
                    </div>
                </div>

                <div class="input-folder">
                    <div class="input-folder--input">
                        <PrimeInputText 
                            v-model="form.email" 
                            id="email" 
                            placeholder=" " 
                            required
                            :class="{'invalid-state-input': form.errors.email}"
                        />
                        <label :class="{
                            'invalid-state': form.errors.email,
                        }" for="email">
                            <p class="paragraph-default">Email</p>
                        </label>
                    </div>
                    <div class="input-folder--support">
                        <p class="input-suport-text invalid-state" v-if="form.errors.email"> {{ form.errors.email }}</p>
                    </div>
                </div>

                <custom-select
                    v-model="selectedAccountLevel"
                    :options="accountLevelOptions"
                    label="Account Level"
                />

                
                    <div class="input-folder--support">
                        <p class="input-suport-text invalid-state" v-if="form.errors.account_level"> {{ form.errors.account_level }}</p>
                    </div>
                <div class="flex-row justify-end">
                    <RothcoCta class="primary" :disabled="form.processing" @click="updateUser">Update User</RothcoCta>
                </div>
            </div>
        </div>
    </div>
</template>
<script lang="ts" setup>
    import { ref, computed, inject, } from "vue";
    import { useForm } from "@/helpers/composables/useForm";
    import { object, string, number} from 'yup';
    import RothcoCta from "@/components/RothcoCta.vue";
    import { useSettingsStore } from "@/store/settings";
    import { storeToRefs } from "pinia";
    import CloseIcon from "@icons/closeIcon.svg";
    const dialogRef = inject('dialogRef');
    let settingsStore = useSettingsStore();
    let { dealer_no } = storeToRefs(settingsStore);
    let route = inject('route');
    const closeDialog = () => {
        dialogRef?.value?.close({ updatedUser: false});
    }

    let accountLevels = computed(()=>({
        1: 'Administrator',
        2: 'See Pricing',
        3: 'Place Orders',
        4: "Basic Display Only"
    }))
    const form = useForm({
        useInertia: false,
        schema: object({
            user_id: number().required(),
            account_level: number().required().test('is_valid_level', 
                'Invalid account level', 
                (value) => {
                    return Object.keys(accountLevels.value).includes(value.toString())
                },
            ),
            username: string().required(),
            email: string().email('Must be a valid email').required(),
        })
    });
    let placeholdersHidden = ref(new Map());
    const hidePlaceholder = (id) => {
        placeholdersHidden.value.set(id, true);
    }
    const showPlaceHolder = (id) => {
        if(form[id] == ""){
            placeholdersHidden.value.set(id, false);
        }
    }
    
    let accountLevelOptions = computed(()=>{
        return Object.keys(accountLevels.value).map((level) => {
            return {
                value: accountLevels.value[level],
                key: level
            }
        })
    })
    

    let selectedAccountLevel = computed({
        get(){
            return accountLevelOptions.value.find((option) => {
                return option.key == form.account_level;
            })
        },
        set(value){
            form.account_level = value.key;
        }
    })

    let user = computed(()=>{
        return dialogRef?.value?.data?.user
    });
    if(user.value.user_id){
        form.user_id = user.value.user_id;
        form.username = user.value.username;
        form.email = user.value.email;
        form.account_level = accountLevelOptions.value.find((option) => option.value == user.value.account_level_name).key;
    }

    function updateUser(){
        if(form.processing) return;
        
        form.put(route('endpoint.user.update', user.value.user_id), {
            user: form.transform((data)=>({
                ...data,
                rothco_dealer_no: dealer_no.value,
            }))
        }, {
            beforeFetch(){
                errors.value = {
                    email: null
                }
            },
            onFetchError(ctx){
                if(ctx.data.error){
                    errors.value = ctx.data.error;
                }
                return ctx;
            },
            afterFetch(ctx){
                if(ctx.data.error){
                    errors.value = ctx.data.error;
                }
                else{
                    dialogRef?.value?.close({ updatedUser: true, })
                }
            }
        })
    }

    let errors = ref({
        email: null
    });


</script>
